import Vue from "vue";
import Empty from "./empty/empty.vue";


Vue.component("Empty", Empty);